module.exports = __webpack_public_path__ + "fonts/iconfont.79fe25e1.woff";